export default __webpack_public_path__ + "static/media/join.196dca9d.png";